// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__E1UWJ"};